export const ROLES_ID = {
  SUPER_ADMIN: 1,
  ADMIN: 2,
  USER: 3,
  MARKETER: 4,
};
